import { preferences as initialState } from '../initialState.tsx';
import {
    REQUEST_SAVE_PREFERENCE,
    RECEIVE_SAVE_PREFERENCE,
    ERROR_SAVE_PREFERENCE,
    REQUEST_LOAD_PREFERENCE,
    RECEIVE_LOAD_PREFERENCE,
    ERROR_LOAD_PREFERENCE,
    REQUEST_LOAD_PREFERENCES,
    RECEIVE_LOAD_PREFERENCES,
    ERROR_LOAD_PREFERENCES
} from 'typeConstants';

const preferences = (state = initialState, action) => {
    switch (action.type) {
        //not sure how to handle errors of loading preferences because i need a payload passed in of the code
        //we were trying to load so i can set its objects isFetching to false, problem is idk how to pass that code in
        //it wont ever error anyways... right? duh
        case RECEIVE_SAVE_PREFERENCE:
        case ERROR_SAVE_PREFERENCE:
        case ERROR_LOAD_PREFERENCE:
        case ERROR_LOAD_PREFERENCES:
            return {...state};
        case REQUEST_SAVE_PREFERENCE:
            return {
                ...state,
                [action.payload.preferenceCode]: {
                    modifiedDate: null,
                    ...(state[action.payload.preferenceCode] ? state[action.payload.preferenceCode] : []),
                    isFetching: false,
                    value: action.payload.value
                }
            };
        case REQUEST_LOAD_PREFERENCE:
            return {
                ...state,
                [action.payload]: {
                    isFetching: true,
                    value: null,
                    modifiedDate: null
                }
            };
        case RECEIVE_LOAD_PREFERENCE:
            return {
                ...state,
                [action.payload.code]: {
                    isFetching: false,
                    value: JSON.parse(action.payload.value),
                    modifiedDate: action.payload.modifiedDate
                }
            };
        case REQUEST_LOAD_PREFERENCES:
            return {
                ...state,
                ...action.payload.reduce((obj, prefCode) => {
                    obj[prefCode] = {
                        isFetching: true,
                        value: null,
                        modifiedDate: null
                    };
                    return obj;
                })
            };
        //the LoadUserPreferences call on the web api side will only return objects for preferences we have
        //this is an issue because that means if we tried loading anything we dont have
        //it will just sit there in an isFetching state forever, the back end needs to be changed or somehow
        //we need access to the original preferences requested here so we can set them to false is fetching
        case RECEIVE_LOAD_PREFERENCES:
            return {
                ...state,
                ...action.payload.reduce((obj, preference) => {
                    obj[preference.code] = {
                        isFetching: false,
                        value: JSON.parse(preference.value),
                        modifiedDate: preference.modifiedDate
                    };
                    return obj;
                })
            };
        default:
            return state;
    }
};

export default preferences;